export const casestudyCarousel = window.onload = () => {
    $('.case-study__slider').slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      variableWidth: false,
      prevArrow:"<img class='a-left control-c prev slick-prev' src='/images/blocks/gallery/prev-arrow.svg' alt='Previous Arrow'>",
      nextArrow:"<img class='a-right control-c next slick-next' src='/images/blocks/gallery/arrow.svg' alt='Next Arrow'>"
    });
}


document.addEventListener('readystatechange', () => {

        casestudyCarousel();

});

